<template>
  <div class="container">
      <div class="topDiv">
          <div class="topDiv_item"  @click="select(1)">
              <span class="topDiv_item_span">{{HT}}</span>
              <img  class="topDiv_item_icon" src="../../assets/images/icon_arrows_filter_normal.png"/>
          </div>
          <div class="topDiv_item" @click="select(2)">
              <span class="topDiv_item_span">{{year}}</span>
              <img  class="topDiv_item_icon" src="../../assets/images/icon_arrows_filter_normal.png"/>
          </div>
      </div>
      <div class="shop_list1 " v-if="dataList.length>0">
            <!-- viewbuttom
            :allLoaded="allLoaded"   :data="billList" @pulldown="false" @loadUp="loadup"  -->
            <scroll :pullup="false" :pulldown="false" :scrollX="true"  >
                 <section @click="pushToDetail(item)"  class="list_cell" v-for="(item,index) in dataList" :key="index"  >
                     <div class="list_item">
                         <span class="list_item_span1">租客名称</span>
                         <!-- billCode -->
                         <span class="list_item_span12">{{item.payerName}}</span>
                         <span :class="[item.settleStatus==1?'list_item_span14':'list_item_span13']">{{item.settleStatus==1?'已付':'未缴'}}</span>
                      </div>
                     <div class="list_item">
                         <span class="list_item_span1">账单编号</span>
                         <!-- arrearsNo -->
                         <span class="list_item_span12">{{item.billCode}}</span>
                     </div>
                     <div class="list_item">
                         <span class="list_item_span1">账单应缴</span>
                         <!-- costAmount -->
                         <span class="list_item_span2">{{item.planAmount.toFixed(2)}}元</span>
                         <span class="list_item_span1">最迟缴款</span>
                         <!-- month | checkMath -->
                         <span class="list_item_span2">{{item.endDate}}</span>
                     </div>

                     <img  v-if="item.waiverAmount && item.waiverAmount>0 &&item.settleStatus!=1" class="list_item_top_icon1" src="../../assets/images/img_overdue.png" />


                 </section>
            </scroll>
       </div>

        <div class="nodataView" v-if="dataList.length==0 &&isLoaded">
             <img class="nodataImage" src="../../assets/images/icon_blank.png"/>
             <span class="nodataspan">无相关账单历史</span>
        </div>

          <!-- // 此处slots为动态传入的值，通过computed来处理，数据通过vuex管理，由于数据为对象数组，需设置 value-key 属性来指定显示的字段名 -->
        <mt-popup  v-model="popupVisible" position="bottom" class="mint-popup">
        <mt-picker class="picker" :slots="pickList" @change="onValuesChange" :visible-item-count="5" :show-toolbar="true" ref="picker" >
            <div class="picker_wrap">
                <div class="picker_btn" @click="popupVisible=false">取消</div>
                <div class="picker_btn2" @click="handleConfirm">确认</div>
            </div>
            </mt-picker>
        </mt-popup>
  </div>
</template>
<script>
import { getContractList,geHistoryBillingByParam ,getOnlineBillingByParam} from "../../utils/api";
import Scroll from "../../components/scroll";
import util from "../../utils/util";
import storage from '../../utils/storage'
import { mapState } from 'vuex';
export default {
  name: "billDetail",
  components: {
     Scroll,
  },
  computed: {
    ...mapState({
      common: state => state.common,
    })
  },
  filters: {
    checkMath(val){
      return val?val.split('-')[1]:'';
    }
  },
  data() {
    return {
      activeTab: 1,
      result:'', //合同数组
      dataList: [],
      allLoaded:true,
      isLoaded:false,
      year:'2019',
      yearList:[{
        flex: 1,
        values:["2019"] ,
        className: 'slot1',
        textAlign: 'center'
      }],
      //["2019","2018","2017","2016","2015","2014","2013","2012","2011","2010"],
      HT:"全部合同",
      HTId:'',
      //HTNameList:["全部合同","合同1","合同2","合同3","合同4","合同5"],
      HtIdList:["","1","2","3","4","5"],

      HTNameList: [{
        flex: 1,
        values:["全部合同"] ,
        className: 'slot1',
        textAlign: 'center'
      }],

      //弹框选择
      pickType:'',
      popupVisible:false,
      pickList:[],
    }
  },

  created(){
      this.initYears();
      this.getContractList();
      this.geHistoryBillingByParam();

  },
  methods: {
      initYears(){
           var currentDate = new Date();
           var endYear = currentDate.getFullYear();
           var yearList =[];
           endYear =parseInt(endYear);
          //  只展示当前以及当年之前15年（不包含当年）的年份可以筛选，现在需要优化成增加当年以及未来15年（不包含当年）年份的筛选

          //  for(var i= endYear ;i>2009;i--){
          //       yearList.push(i);
          //  }
          for(var i=15;i>=0;i--){ //后15年 和当年
             yearList.push(i+endYear);
          }
          for(var i=1;i<=15;i++){ //前15年
             yearList.push(endYear-i);
          }

           this.yearList[0].values=yearList;
           this.year=endYear;
      },

     getContractList(){
        let params = {
            'userId': this.common.userId,
            companyId:String(this.common.userTenantInfo.companyId) ,
            "pageNo": 1,
            "pageSize": 100,
            "permissionType": 'BILL'
        }
         getContractList(params).then(res => {
             var nameList =["全部合同"];
             var idList =[];
             if (res.res.code === 10000 && res.body) {

                let data = res.body;
                var list = data.contractList;
               
                for(var i=0;i<list.length;i++){
                    for(var j=0;j<list.length- 1 - i;j++){
                      if (list[j].contEndDate<list[j + 1].contEndDate) {
                          [list[j], list[j + 1]] = [list[j + 1], list[j]];
                        }
                    }
                }
                
                this.result =list //data.contractList;
                for(var i=0;i<this.result.length;i++){
                    nameList.push(this.result[i].contNo+'['+util.formatTime(new Date(this.result[i].contBeginDate),6)+'-'+ util.formatTime(new Date(this.result[i].contEndDate),6)+']');
                    idList.push(this.result[i].localId);
                }
             }

             this.HTNameList[0].values=nameList;
             this.HtIdList =idList;
         });


     },


    //上拉
     loadup(){

     },

     //下拉刷新
     loadData(){

     },

     geHistoryBillingByParam(){
          let params = {
            userId: this.common.userId,
            year: String(this.year) ,
          }
          if(this.HTId){
            params.contId= this.HTId;
          }
           getOnlineBillingByParam(params).then(res => {
               console.log(res)
               this.isLoaded= true;
                if (res.res.code == 10000 && res.body) {
                    let data = res.body;
                    var list = data.normalBill;
                    for(var i=0;i<list.length;i++){
                    var item = list[i];
                    if(!item.feeCodeName ||item.feeCodeName==undefined){
                       item.feeCodeName ='其他';
                    }
                }
                    this.dataList = list;
                }else{
                    util.showToast(res.res.msg,2);
                }
           });

     },

     select(pickType){
         this.pickType=pickType;
         this.popupVisible=true;
         if(this.pickType==1){
             this.pickList = this.HTNameList;
         }else{
             this.pickList = this. yearList;
         }

     },
     onValuesChange (picker, values) {
        if (values[0] > values[1]) {
            picker.setSlotValue(1, values[0]);
        }
     },

     handleConfirm(){
        this.popupVisible = false
        var valve =  this.$refs.picker.getValues()[0];
        if(this.pickType==1){
          var htNames = valve.split('[')
            this.HT=  htNames&&htNames[0]?htNames[0]:valve
            var list =this.HTNameList[0].values;
            for(var i=0;i<list.length;i++){
                if(valve==list[i]){
                    if(i==0){
                        this.HTId='';
                    }else{
                        this.HTId=this.HtIdList[i-1];
                    }
                   // break;
                }
            }
        }else{
            this.year=valve
        }
        console.log(this.yeary);
        this.geHistoryBillingByParam();

     },

     pushToDetail(item){
        if(!item.waiverAmount){
           item.waiverAmount=0;
         }
         if(!item.needPayAmount){
           item.needPayAmount=0;
         }
         if(!item.planAmount){
           item.planAmount=0;
         }
          if(!item.realAmount){
           item.realAmount=0;
         }
      //  var param = "contCode="+item.contCode+"&subProjectName="+item.subProjectName+"&endDate="+item.endDate+
      //   "&settleStatus="+item.settleStatus+"&billCode="+item.billCode+'&feeCodeName='+item.feeCodeName+
      //   "&realAmount="+item.realAmount+"&checkStatus="+item.checkStatus+"&reqStatus="+item.reqStatus+
      //   "&feeCode="+item.feeCode+"&subProjectId="+item.subProjectId+"&payerName="+item.payerName+
      //   "&needPayAmount="+item.needPayAmount+"&id="+item.id+"&startDate="+item.billStartDate+"&billEndDate="+item.billEndDate+
      //   "&planAmount="+item.planAmount+"&waiverAmount="+item.waiverAmount+"&receiptId="+item.receiptId;
      //   var url ='/billDetail?' +param;
      //   this.$router.push(url);
          storage.setS('billDetailString', JSON.stringify(item))
        setTimeout(() => {
            var url ='/billDetail';
            //  var url ='/billDetail?' +param;
            this.$router.push(url);
        }, 100)
     },

  }
}

</script>

<style lang="less" scoped>
@import "../../assets/css/common.less";
.container {
  height: 100vh;
  background-color: #EDEDED;
  .flex(column);
  .shop_list1 {
    flex: 1;
     height: 500px;
  }
}

.topDiv{
    width: 100%;
    height: 88px;
    flex-direction: row;
    background:#EDEDED;
    display: flex;
}
.topDiv_item{
    height: 88px;
    width: 50%;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    display: flex;
}
.topDiv_item_span{
    height:40px;
    font-size:28px;
    font-weight:400;
    color:rgba(51,51,51,1);
    line-height:40px;
}

.topDiv_item_icon{
    width: 24px;
    height: 24px;
    margin-left: 16px;
    display: flex;
}

.list_cell{
    width:100%;
    padding-bottom: 28px;
    padding-top: 8px;
    background:rgba(255,255,255,1);
    flex-direction: column;
    display: flex;
    position: relative;
    margin-bottom: 14px;
}
.list_item_top_icon1{
    position: absolute;
    top: 0;
    right:218px ;
    width: 100px;
    height: 78px;
}
.list_item{
    margin-top: 20px;
    flex-direction: row;
    margin-left: 28px;
    margin-right: 28px;
    width: 694px;
    display: flex;
}

.list_item_span1{
  width: 124px;
  height:34px;
  font-size:24px;
  font-weight:400;
  color:rgba(153,153,153,1);
  line-height:34px;
  display: flex
}
.list_item_span2{
  width: 223px;
  font-size:24px;
  font-weight:400;
  color:rgba(51,51,51,1);
  line-height:34px;
  display: flex
}

.list_item_span12{
  width: 500px;
  font-size:24px;
  font-weight:400;
  color:rgba(51,51,51,1);
  line-height:34px;
  display: flex
}
.list_item_span13{
  width: 62px;
  text-align: right;
  word-break: break-all;
  height:40px;
  font-size:28px;
  font-weight:400;
  color:rgba(153,153,153,1);
  line-height:40px;
  display: flex
}

.list_item_span14{
   width: 62px;
  text-align: right;
  word-break: break-all;
  height:40px;
  font-size:28px;
  font-weight:400;
  color:#FC3F56;
  line-height:40px;
  display: flex

}


//pick
.picker {
    width:100%;
}
.picker-items {
    height: 100px!important;
}
.picker_wrap {
    height: 100px;
    display: flex;
    justify-content: space-between;
    padding: 0 28px;
    box-sizing: border-box;
}
.picker_btn,
.picker_btn2 {
    flex: 1;
    font-size: 32px;
    text-align: left;
    line-height: 100px;
}
.picker_btn2 {
    text-align: right;
    color: @color17;
}

.nodataView{
    width: 100%;
    height: 500px;
    flex: 1;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    display: flex;

  }
  .nodataImage{
    width: 200px;
    height: 200px;
  }
  .nodataspan{
      margin-top: 10px;
    height:40px;
    font-size:28px;
    font-weight:400;
    color:rgba(153,153,153,1);
    line-height:40px;
  }


</style>